let domLoaded = false;
let igReady = false;

// V_DH_SITE_12 anti-flicker: the header group stays hidden (c-custom.css) until the group is known.
// Control is revealed here; Var A is revealed by assets/c-custom.js once the fonts are scaled.
document.documentElement.classList.add("c-vDhSite12Pending");

function revealSite12() {
  document.documentElement.classList.remove("c-vDhSite12Pending");
}

// Intelligems blocked or very slow: never leave the page hidden
setTimeout(revealSite12, 3000);

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  // Test: V_DH_PDP_10 — Clickable Benefit Tabs in PDP Hero
  const vDhPdp10Group = window.igData?.user.getTestGroup(
    "97f49708-e7ce-40c3-9e33-b0b52f21afe5"
  );
  if (vDhPdp10Group?.name === "Var A") {
    document.body.classList.add("c-vDhPdp10VarA");
  }

  // Test: V_DH_SITE_12 — Larger Text Sizes Sitewide for 55+ Readability
  const vDhSite12Group = window.igData?.user.getTestGroup(
    "fc608619-4c27-48b6-aaff-b2580835f262"
  );
  if (vDhSite12Group?.id === "8feddd25-3e41-438e-9143-d8f23be2cf33") {
    document.body.classList.add("c-vDhSite12VarA");
  } else {
    revealSite12();
  }

    // Test: V_DH_CART_11 — Cart Sell-Out Urgency + Delivery Date
    const vDhCart11Group = window.igData?.user.getTestGroup(
      "c943cb43-d65a-4d25-9beb-42c0e9082fe2"
    );
    if (vDhCart11Group?.id === "6d14399b-f2e3-4e95-8c05-b092827dc974") {
      document.body.classList.add("c-vDhCart11VarA");
    } else if (vDhCart11Group?.id === "95d6df39-e963-44c3-9246-24bb7557c12e") {
      document.body.classList.add("c-vDhCart11VarB");
    }
}

// Test: V_DH_SITE_16 — Fall Sale Announcement Banner
// The section hides both the trust bar and the sale banner until one of these classes is on <html>.
// <html> exists already, so this runs straight on ig:ready instead of waiting for DOMContentLoaded.
const vDhSite16Classes = {
  "5452b7ce-4f45-4c79-84a5-68226a7c2884": "c-vDhSite16VarA",
  "a45b26c6-08cb-4642-943c-d09b9d7a4452": "c-vDhSite16VarB",
  "092d9b69-a804-42a1-8016-349e68bf1c05": "c-vDhSite16VarC",
};

function setSite16Class(className) {
  const root = document.documentElement;
  root.classList.remove(
    "c-vDhSite16Control",
    ...Object.values(vDhSite16Classes)
  );
  root.classList.add(className);
}

function handleSite16() {
  const vDhSite16Group = window.igData?.user.getTestGroup(
    "ed5673fd-c687-4cc1-bcc6-6bdc61443e21"
  );
  // Control, or not in the test: show the trust bar
  setSite16Class(vDhSite16Classes[vDhSite16Group?.id] || "c-vDhSite16Control");
}

// Intelligems blocked or very slow: fall back to the Control trust bar rather than no bar at all
setTimeout(() => {
  if (!igReady) setSite16Class("c-vDhSite16Control");
}, 3000);

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleSite16();
  handleExperiments();
});
